import React from 'react';
import './EntityState.scss';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import { useGetEntityStatusQuery } from '@/rtk/entityStatusApi';
import { useUrlEntityId } from '../App/hooks';

export default function EntityStatus(): React.ReactElement {
  const entityId = useUrlEntityId();

  const { data: entityStatus } = useGetEntityStatusQuery(entityId, {
    skip: !entityId,
    pollingInterval: 60000,
  });

  return entityStatus?.status === 'Online' ? (
    <div className="online-state">
      <RadioButtonCheckedIcon fontSize="small" />
      <span>{entityStatus.status} robot</span>
    </div>
  ) : (
    <div className="offline-state">
      <CloudOffIcon fontSize="small" />
      <span>Offline robot</span>
    </div>
  );
}
